import React, { Component } from "react";
import {
	View,
	Text,
	StyleSheet,
	KeyboardAvoidingView,
	Platform,
	WebView,
} from "react-native";

import ProgressIndicator from "components/ProgressIndicator";

import * as x from "styles/css";

class Webview extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
		}

		this.loaded = this.loaded.bind(this);
	}

	componentDidMount() {
		window.addEventListener("message", this.props.connected, false);
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.props.connected);
	}

	loaded() {
		console.log("loaded");
		this.setState({
			loading: false,
		})
	}

	render() {
		return (
			<div style={{ flex: 1}}>
				<View style={[styles.indicator]}>
					{this.state.loading && <ProgressIndicator
						loading={!this.state.paused}
						color={x.colors.default}
					/>}
				</View>
				<iframe
					ref={ref => {
						this.frame = ref;
					}}
					style={{ flex: 1 }}
					id="devicewifi"
					title="devicewifi"
					width="100%"
					height="100%"
					onLoad={this.loaded}
					frameborder="0"
					marginheight="0"
					marginwidth="0"
					src={this.props.url}
				/>
				</div>
		);
	}
}

const styles = StyleSheet.create({
	indicator: {
		height: 10,
	},
});

export default Webview;



// WEBPACK FOOTER //
// ./src/views/DeviceAuth/Webview/index.web.js